import { STORE_PAGINATION } from '../actions/actionTypes';

const initialState = {
    currentPage: 1,
    pageCount: 1
};

export default function reducers(state = initialState, action) {
    switch (action.type) {
        case STORE_PAGINATION:
            return action.payload;
        default:
            return state;
    }
}
